import React, { PureComponent } from 'react'
import Markdown from 'react-remarkable'
import './index.css'

class MessagePreview extends PureComponent {
  render() {
    const { content, name } = this.props

    return (
      <div className={ 'messagePreview' }>
        <div className={ 'messagePreview-content' }>
          <Markdown>
            { content }
          </Markdown>
        </div>
        <div className={ 'messagePreview-name' }>
          { name }
        </div>
      </div>
    )
  }
}

export default MessagePreview



// WEBPACK FOOTER //
// ./src/components/MessagePreview/index.js